module.exports = __webpack_public_path__ + "static/media/SaintMaryoftheAnnunciationSchoolDanvers.df8d544b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SaintMaryoftheAnnunciationSchoolDanvers.jpg
// module id = 686
// module chunks = 0